/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { memo, useState, useEffect } from 'react';
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';

import { convertFromRaw } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import { Typography } from '../../components/Typography';
import { Card } from '../../components/Card';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { selectSettings } from '../settings/settings.slice';
import { actions as appActions } from '../app/app.slice';

const styles = (theme: Theme) => {
  return createStyles({
    root: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    card: {
      flexGrow: 1,
      overflow: 'auto',
      marginTop: theme.spacing(2),
    },
  });
};

type IHelpView = WithStyles<typeof styles>;

const HelpView: React.FC<IHelpView> = ({ classes }) => {
  const settings = useAppSelector(selectSettings);
  const dispatch = useAppDispatch();
  const [help, setHelp] = useState<string>('');
  useEffect(() => {
    let data;
    if (settings?.data?.help) {
      data = stateToHTML(convertFromRaw(JSON.parse(settings?.data?.help)));
      setHelp(data);
    }
  }, [settings?.data?.help]);

  useEffect(() => {
    dispatch(appActions.setLocationCode('10113'));
  }, []);

  return (
    <div className={classes.root}>
      <Typography variant="h4" component="h2" color="textPrimary">
        <FormattedMessage id="help" />
      </Typography>
      <Card customStyles={classes.card}>
        <div dangerouslySetInnerHTML={{ __html: help }} />
      </Card>
    </div>
  );
};

export default memo(withStyles(styles)(HelpView));
